(function () {
  function getForm(radio, root) {
    const formId = (radio && radio.getAttribute('form')) || (root && root.getAttribute('data-product-form'));
    return formId ? document.getElementById(formId) : radio && radio.closest('form');
  }

  function updateAtcButton(form, available) {
    if (!form) return;
    const button = form.querySelector('[name="add"], .product-form__submit');
    if (!button) return;

    const label = button.querySelector('.main-atc__label__text');
    const price = button.querySelector('.main-atc-price');
    const customLabel = button.getAttribute('data-custom-label');

    if (available) {
      button.disabled = false;
      button.removeAttribute('data-unavailable');
      button.removeAttribute('aria-disabled');
      if (price) price.classList.remove('hidden');
      if (label) {
        const freqOn = document.querySelector('.freq__input:checked, .freq.on');
        const baseLabel = button.getAttribute('data-atc-base') || (customLabel || '').replace(/\s*[&+]?\s*SAVE\s+\d+%\s*/i, '').trim();
        if (freqOn && customLabel) {
          label.textContent = customLabel;
        } else {
          label.textContent = baseLabel || customLabel || label.dataset.defaultLabel || label.textContent;
        }
      }
    } else {
      button.disabled = true;
      button.setAttribute('data-unavailable', 'true');
      if (price) price.classList.add('hidden');
      if (label) {
        if (!label.dataset.defaultLabel && customLabel) {
          label.dataset.defaultLabel = customLabel;
        }
        label.textContent = button.getAttribute('data-soldout-label') || 'Sold out';
      }
    }
  }

  function syncBundleCard(radio) {
    if (!radio) return;

    const root = radio.closest('.vbc');
    if (root) {
      root.querySelectorAll('.vbc-tier').forEach(function (tier) {
        tier.classList.toggle('on', tier.contains(radio) && radio.checked);
      });
    }

    const form = getForm(radio, root);
    if (!form) return;

    const qtyInputs = form.querySelectorAll('input[name="quantity"]');
    if (qtyInputs.length) {
      qtyInputs.forEach(function (input) {
        input.value = '1';
      });
    }
    if (root) {
      const fallback = root.querySelector('input.vbc-qty');
      if (fallback) fallback.value = '1';
      const tubsInput = root.querySelector('input.vbc-tubs');
      if (tubsInput) tubsInput.value = radio.getAttribute('data-tubs') || '1';
    }

    const variantId = radio.getAttribute('data-variant-id');
    if (variantId) {
      const idInput = form.querySelector('.product-variant-id, input[name="id"]');
      if (idInput) idInput.value = variantId;
    }

    updateAtcButton(form, radio.getAttribute('data-available') !== 'false');
  }

  function onChange(event) {
    const radio = event.target.closest && event.target.closest('.vbc input[type="radio"]');
    if (!radio || !radio.checked) return;
    syncBundleCard(radio);
  }

  function onClick(event) {
    const tier = event.target.closest && event.target.closest('.vbc-tier');
    if (!tier) return;
    const radio = tier.querySelector('input[type="radio"]');
    if (!radio || radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function init() {
    document.querySelectorAll('.vbc input[type="radio"]:checked').forEach(syncBundleCard);
  }

  document.addEventListener('change', onChange);
  document.addEventListener('click', onClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);
})();
